export const CACHE_TIME_3_DAYS = 259200; // seconds
export const CACHE_TIME_15_MINUTES = 900; // seconds